export const PROPERTY_CONFIG_HEADER = {
  BREADCRUMB_LABEL: "Property Profile",
  HELP_TEXT: "To update any information, please contact the Hotel Trader Team.",
  CONTACT_BUTTON_TEXT: "Contact Us",
};

export const CONTACT_US_MODAL = {
  TITLE: "Property Profile Update",
  SECTION_TITLE: "What would you like to update?",
  DESCRIPTION_TITLE: "Description",
  DESCRIPTION_SUBTITLE: "Provide specific details for each change you need",
  TEXTAREA_PLACEHOLDER: "Anything else you'd like us to know?",
  CANCEL_BUTTON_TEXT: "Cancel",
  SEND_BUTTON_TEXT: "Send Request",
  CHECKBOX_OPTIONS: [
    { key: "property_information", label: "Property Information" },
    { key: "room_types", label: "Room Types" },
    { key: "rate_plans", label: "Rate Plans" },
    { key: "policies", label: "Policies" },
    { key: "taxes_fees", label: "Taxes & Fees" },
  ],
  CLOSE_BUTTON_TEXT: "Close",
  SUCCESS_TITLE: "Your request has been submitted.",
  SUCCESS_RESPONSE_TIME:
    "The Hotel Trader team will respond within 24–48 business hours.",
  SUCCESS_APPROVAL_NOTE: "Once approved, the updated content will appear here.",
};
